import { render } from "./GeneratePDF.vue?vue&type=template&id=6ba4ad00"
import script from "./GeneratePDF.vue?vue&type=script&lang=js"
export * from "./GeneratePDF.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__